import React from 'react';

function Register() {
  return (
    <div className="min-h-screen bg-dark flex items-center justify-center">
      <h1 className="text-white text-3xl font-bold">Page Register - À venir</h1>
    </div>
  );
}

export default Register;